export const dismissedSelector = (state) => state.ui.dismissible;
